<!--page starts-->
<section class="page-wrapper zero-tolerance-section cf">
    <div class="news-bottom-section margin-top-152 cf">
       <div class="container">
           <div class="news-bottom-detail cf">
                <div class="titel-box cf">
	      	 		<h2 class="titel-name">ZERO TOLERANCE POLICY</h2>
	      	 	</div>
                <div class="new-single-detail cf">
                    <div class="new-single-content">
                        <h3>LEICESTERSHIRE COUNTY CRICKET CLUB (LCCC) MAINTAINS ZERO TOLERANCE POLICY ON DISCRIMINATION OF ANY KIND</h3>
                        <p>LCCC has a zero tolerance policy on discrimination of any kind.</p>
                        <p>The Club strives to maintain an inclusive environment in which no individual, group or organisation experiences any form of discrimination, or feels excluded in any way.</p>
                        <p>We have no excuses – discrimination will never be excused or tolerated in the Foxes Family. In particular, this includes, but is not limited to, the use of language on and off the field of play.</p>
                        <p>As a Club we continue to learn, to educate, and improve, whilst firmly maintaining our zero-tolerance policy on all forms of discrimination.</p>
                    </div>
                    
                </div>
	      	 	
           </div> 
       </div>
    </div>
</section><!-- page ends-->